import { createFileRoute, redirect } from '@tanstack/react-router';

import { Upgrade } from '@/features/organizations';
import { checkOrganizationTrialStatus } from '@/hooks';

export const Route = createFileRoute('/_auth/_org/upgrade')({
  beforeLoad: async ({ context: { client } }) => {
    const organization = await client.getOrganization('me');
    const { hasUpgraded } = checkOrganizationTrialStatus(organization);

    if (hasUpgraded) {
      throw redirect({ to: '/' });
    }
  },
  component: Upgrade,
});
